import { render } from "./RichComponent.vue?vue&type=template&id=8693bbf6"
import script from "./RichComponent.vue?vue&type=script&lang=js"
export * from "./RichComponent.vue?vue&type=script&lang=js"

import "./RichComponent.vue?vue&type=style&index=0&id=8693bbf6&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__